export default "__VITE_ASSET__5VNPBqK3__"